import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { LoadingState } from './EmptyState';

/**
 * Blocks access unless logged in AND Admin. `isAdmin` comes from
 * useAuth(), derived from the backend-sourced user.department (see
 * AuthContext.js) -- never trusted from localStorage alone, and the
 * backend independently re-checks Admin on every request this page makes.
 */
export default function AdminRoute({ children }) {
  const { user, loading, isAdmin } = useAuth();
  const location = useLocation();

  if (loading) return <LoadingState label="Checking your session" />;
  if (!user) return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  if (!isAdmin) return <Navigate to="/unauthorized" replace />;

  return children;
}
